export default __webpack_public_path__ + "static/media/970.4bcb9459.png";